module.exports = __webpack_public_path__ + "img/gear.4d606d09.svg";